import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import React, {forwardRef, useContext, useEffect, useState} from "react";

import Meta from "../common/Meta";
import {AppContext} from "../../lib/AppContext";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Footer from "../Footer";
import {getReportByTypeRange, getReportByTypeYearMonth} from "../common/api/ReportApi";
import {CardContent, Chip, Link} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import Loading from "../common/Loading";
import {displayPhone, formatDateMask, formatDateTime} from "../common/Utils";
import BootyPagination from "../common/bootyPagination";
import DataTable from "react-data-table-component";
import * as pagination from "../common/pagination";
import {useForm} from "react-hook-form";
import Icon from "@mui/material/Icon";
import {BarChart} from '@mui/x-charts/BarChart';
import MDButton from "../../components/MDButton";
import StatisticsCard from "./card/StatisticsCard";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import moment from "moment/moment";
import {getCookie, setCookie} from "../common/appCookie";
import Switch from "@mui/material/Switch";
import {Col} from "react-bootstrap";
import FileSelector from "../calendarUI/FilterSelector";

export default function CustomersDetails({type, range}) {
  const widthFn = () => {
    let w = parseInt(window.innerWidth, 10) * .5;
    return parseInt(window.innerWidth, 10) * .5;
  }
  const [docWidth, setDocWidth] = useState(100);

  useEffect(() => {
    function handleWidthFn() {
      setDocWidth(widthFn());
    }

    window.addEventListener("resize", handleWidthFn);
    handleWidthFn();
    return () => window.removeEventListener("resize", handleWidthFn);
  }, []);

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();
  const [reportPeriod, setReportPeriod] = useState();

  const [reportData, setReportData] = useState();

  const [eventDate, setEventDate] = useState();
  const [eventEndDate, setEventEndDate] = useState();

  const _BootyPagination = {...BootyPagination};
  let {reportYear, reportMonth, reportEndYear, reportEndMonth} = useParams();

  useEffect(() => {

    let _period = reportYear + '/' + reportMonth;
    setReportPeriod(_period);
    let _d = new Date();
    _d.setFullYear(reportYear);
    let m = moment(reportMonth, 'MMM')
    _d.setMonth(m.month());
    setEventDate(_d);

    if (!range) {
      setReportEndPeriod(_period);
      setEventEndDate(_d);

      getCustomerReportByYearMonthFn(_period);

      return;
    }

    let _endPeriod = reportEndYear + '/' + reportEndMonth;
    setReportEndPeriod(_endPeriod);

    let _dd = new Date();
    _dd.setFullYear(reportEndYear);
    let mm = moment(reportEndMonth, 'MMM')
    _dd.setMonth(mm.month());

    setReportEndPeriod(_endPeriod);
    setEventEndDate(_dd);

    getSalesReportByRangeFn(_period, _endPeriod);

  }, []);

  useEffect(() => {
    _BootyPagination.reportData = {...reportData};
  }, [reportData]);


  const [labels, setLabels] = useState();
  const [chartData, setChartData] = useState();

  const formatChartData = (report) => {
    setChartData(report?.pieChartData);
    let types = [];
    for (let j in report?.pieChartData) {
      types.push({
        id: report?.pieChartData[j].id,
        sortOrder: report?.pieChartData[j].id,
        name: report?.pieChartData[j].label
      });
      setFilterTypes(types);
    }
  }

  const getSalesReportByRangeFn = (startPeriod, endPeriod) => {

    setReportData(null);

    getReportByTypeRange(type, startPeriod, endPeriod).then(r => {
      if (r.error) {
        setContext({...context, error: {message: r.message}});
        setReportData({});
      } else {
        setReportData(r);
        formatChartData(r);
      }
    });

  }

  const getCustomerReportByYearMonthFn = (period) => {

    setReportData(null);

    getReportByTypeYearMonth(type, period).then(r => {
      if (r.error) {
        setContext({...context, error: {message: r.message}});
        setReportData({});
      } else {
        setReportData(r);
        formatChartData(r);
      }
    });

  }


  const DisplayReferenceId = ({tableRow}) => {

    const [row, setRow] = useState(tableRow);
    let id = row.referenceId;
    if (!id) {
      return '';
    }
    let descPart = id.substring(0, 3);
    let finalPart = id.substring(id.length - 4, id.length);
    return (
      <span
        className="cursor-pointer"
        onClick={() => {
          let _r = {...row};
          _r.fullId = !!!_r.fullId;
          setRow(_r);
        }}>
        {row.fullId ? <>{id}</> :
          <Chip
            label={descPart + '...' + finalPart}
            variant="outlined"
            color="secondary"

          />
        }
      </span>
    )
  }
  const handleViewCustomer = (row) => {
    navigate('/client/' + row.guid);
  }

  function compareNumericString(rowA, rowB, id, desc) {
    const defaultVal = desc ? 'AAAAAAAAAAAA' : 'ZZZZZZZZ';
    return (rowA.values[id] ?? defaultVal)
      .localeCompare(rowB.values[id] ?? defaultVal);
  }


  const customSort = (rows, selector, direction) => {
    return rows.sort((a, b) => {
      // use the selector to resolve your field names by passing the sort comparators
      const aField = selector(a).toLowerCase();
      const bField = selector(b).toLowerCase();

      let comparison = 0;

      if (aField > bField) {
        comparison = 1;
      } else if (aField < bField) {
        comparison = -1;
      }

      return direction === 'desc' ? comparison * -1 : comparison;
    });
  };

  const _columns = [

    {
      name: <span className='th'>Customer</span>,
      id: 1,
      selector: row => row?.lastName + ' ' + row?.firstName,
      cell: row => {
        return <Link className="link"
                     href={'/client/' + row?.guid}>
          {row?.lastName + (row?.firstName ? ', ' + row?.firstName : '')}
        </Link>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Email</span>,
      id: 2,
      selector: row => row?.email?.toUpperCase(),
      cell: row => {
        return <>{row.email && <Link className="link"
                                     href={'/email/client/' + row.guid + '?address=' + row.email}>
          {row.email}
        </Link>}&nbsp;</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Phone</span>,
      id: 13,
      selector: row => row?.email?.toUpperCase(),
      cell: row => {
        return <>{displayPhone(row.primaryPhone || '')}</>;
      },
      sortable: false,
    },
    {
      name: <span className='th'>Address</span>,
      id: 14,
      selector: row => row?.email?.toUpperCase(),
      cell: row => {
        return <>{row.displayAddress || ''}</>;
      },
      sortable: false,
    },
    {
      name: <span className='th'>Created On</span>,
      id: 3,
      selector: row => new Date(row.createDate).getTime(),
      cell: row => {
        return formatDateTime(row.createDate);
      },
      sortType: (a, b) => {
        return new Date(b.values.createDate) - new Date(a.values.createDate);
      },
      sortable: true,
    },
    {
      name: <span className='th'>Created By</span>,
      id: 15,
      selector: row => row.createUser?.lastName + ' ' + row.createUser?.firstName,
      cell: row => {
        return <>{row.createUser?.lastName + (row.createUser?.firstName ? ', ' + row.createUser?.firstName : '')}</>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Referral</span>,
      id: 19,
      selector: row => row.referralTypeName,
      sortable: true,
    },
  ];
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [columns, setColumns] = useState(_columns);
  const [searchParams, setSearchParams] = useSearchParams();
  const [startPage, setStartPage] = useState(searchParams.get('startPage') || 0);
  const handlePageChange = (selector, page) => {
    setStartPage(selector);
  };

  const [render, setRender] = useState(1);
  const [sortDir, setSortDir] = useState(searchParams.get('sortDir') || 'asc');
  const [sortOrder, setSortOrder] = useState(searchParams.get('sortOrder') || 1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggledClearRows, setToggledClearRows] = useState(false);

  const handleRowSelected = React.useCallback(state => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleClearRows = () => {
    setToggledClearRows(!toggledClearRows);
  };

  const composeEmail = () => {
    let ids = []
    for (const j in selectedRows) {
      ids.push(selectedRows[j].guid);
    }
    if (ids.length === 1) {
      navigate('/email/client/' + ids[0], {replace: false});
    } else {
      navigate('/email/clients/' + ids.join(','), {replace: false});
    }
  }

  const exportCsv = () => {
    let _rows = {...reportData};
    let d = _rows?.reportItems;
    let filename = 'Customer-Export-' + formatDateMask(new Date(), 'MM-DD-YYYY-hh-mm-ss') + '.csv';

    let rows = [];
    let _dd = [];
    _dd.push("Customer Last Name");
    _dd.push("Customer First Name");
    _dd.push("Email");
    _dd.push("Phone");
    _dd.push("Address");
    _dd.push("Created On");
    _dd.push("Created By");
    _dd.push("Referral");

    rows.push(_dd);

    for (let j in d) {
      let _dd = [];
      _dd.push(d[j]?.lastName);
      _dd.push(d[j]?.firstName);
      _dd.push(d[j]?.email);
      _dd.push(displayPhone(d[j]?.primaryPhone || ''));
      _dd.push(d[j].displayAddress);
      _dd.push(formatDateTime(d[j].createDate));
      _dd.push(d[j].createUser?.firstName + " " + d[j].createUser?.lastName);
      _dd.push(d[j].referralTypeName || 'None');

      rows.push(_dd);
    }

    let data = rows.map(row =>
      row
        .map(String)  // convert every value to String
        .map(v => v.replaceAll('"', '""'))  // escape double quotes
        .map(v => `"${v}"`)  // quote it
        .join(',')  // comma-separated
    ).join('\r\n');

    var blob = new Blob([data], {type: 'text/csv;charset=utf-8;'});
    if (navigator.msSaveBlob) { // IE 10+
      navigator.msSaveBlob(blob, filename);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }

  const handleSort = (column, sortDirection) => {
    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('CUSTOMER_REPORT_SORT', column.id);
    setCookie('CUSTOMER_REPORT_SORT_DIR', sortDirection);
    setRender(render + 1);
  };

  const [reportEndPeriod, setReportEndPeriod] = useState();
  const [rangeReport, setRangeReport] = useState(range || false);

  const toggleReportRange = () => {
    setRangeReport(!rangeReport)
  }

  const [filterTypes, setFilterTypes] = useState([]);
  const [typeFilter, setTypeFilter] = useState([]);

  const resultsFiltered = (data) => {
    if (!typeFilter || typeFilter.length === 0) {
      return data;
    }
    let _fd = [];
    for (const j in data) {
      let key = parseInt(data[j]?.referralType?.id, 10);
      for (const f in typeFilter) {
        if (parseInt(typeFilter[f], 10) === key) {
          _fd.push(data[j]);
        }
      }
    }
    return _fd;
  }

  const getReport = () => {
    if (rangeReport) {
      getSalesReportByRangeFn(reportPeriod, reportEndPeriod);
      navigate(`/${type}/report/${reportPeriod}/${reportEndPeriod}`, {replace: true});
    } else {
      getCustomerReportByYearMonthFn(reportPeriod);
      navigate(`/${type}/report/${reportPeriod}`, {replace: true});
    }
  }

  const updateEventDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventDate(_d);
    setReportPeriod(_period);
  }

  const updateEventEndDates = (date) => {
    let _d = new Date(date);
    let _period = (_d.getFullYear()) + '/' + formatDateMask(_d, 'MMM');
    setEventEndDate(_d);
    setReportEndPeriod(_period);
  }

  const {register, handleSubmit, setValue, control} = useForm({});

  const FormattedDateInput = forwardRef(({value, onClick}, ref) => (
    <span className={'cursor-pointer'} onClick={onClick} ref={ref}>
      <MDTypography variant="h5" color="secondary" fontWeight="light" sx={{
        display: 'inline-block'
      }}>
        <Icon sx={{
          marginTop: '2px',
        }}>event</Icon>Report Date - {formatDateMask(eventDate, 'MMMM yyyy')}
      </MDTypography>
    </span>
  ));

  const valueFormatter = (value) => value;

  return (

    <DashboardLayout>

      <Meta pageTitle={'Customers Report'}/>

      <ContextSearchNavbar title="Customers Report"/>

      <MDBox py={3}>
        <MDBox mb={3}>

          {!reportData && <Loading/>}
          {reportData && <Grid container spacing={1} mb={2}>

            <Grid item xs={12} sm={8}>

              <DesktopDatePicker
                sx={{
                  '& .MuiInputBase-root': {
                    borderRadius: '4px 0 0 4px'
                  }
                }}
                closeOnSelect={false}
                views={['month', 'year']}
                maxDate={dayjs()}
                slotProps={{
                  actionBar: {
                    actions: ['today', 'accept'],
                  },
                }}
                value={dayjs(eventDate)}
                onChange={(e) => {
                  updateEventDates(e?.$d || null);
                }}
              />
              {rangeReport &&
                <DesktopDatePicker
                  sx={{
                    '& .MuiInputBase-root': {
                      borderRadius: '4px 0 0 4px'
                    }
                  }}
                  closeOnSelect={false}
                  views={['month', 'year']}
                  minDate={dayjs(eventDate)}
                  maxDate={dayjs()}
                  slotProps={{
                    actionBar: {
                      actions: ['today', 'accept'],
                    },
                  }}
                  value={dayjs(eventEndDate)}
                  onChange={(e) => {
                    updateEventEndDates(e?.$d || null);
                  }}
                />}
              <MDButton
                sx={{
                  borderRadius: '0 4px 4px 0',
                  height:'44px'
                }}
                color="info"
                onClick={() => {
                  getReport();
                }}
              >Go</MDButton>
            </Grid>
            <Grid item xs={12} sm={4} justifyContent="flex-end" alignItems="flex-end" style={{
              paddingRight:'12px'
            }}>
                <FileSelector
                  width={'100%'}
                  types={filterTypes}
                  typeFilter={typeFilter}
                  filterLabel={'Referral Types'}
                  labelBackground={'#f0f2f5'}
                  setFilter={(filters) => {
                    setTypeFilter(filters)
                  }}
                />
            </Grid>
            <Grid item xs={12}>
              <Col xs={12}>
                <label
                  htmlFor="rangeReport">
                  Date Range
                  <Switch
                    name={'rangeReport'}
                    id={'rangeReport'}
                    checked={rangeReport}
                    style={{marginRight: '5px'}}
                    onChange={toggleReportRange}
                  /> </label>
              </Col>
            </Grid>
            <Grid item sm={8} xs={12}>
              <Card>
                <CardContent sx={{
                  height: '320px'
                }}>
                  <MDTypography variant="h5" fontWeight={"light"}>
                    Referral Types
                  </MDTypography>
                  {chartData && <BarChart
                    tooltip={{trigger: 'item'}}
                    grid={{vertical: true, horizontal: true}}
                    dataset={chartData}

                    xAxis={[
                      {
                        scaleType: 'band',
                        dataKey: 'label',
                        colorMap: {
                          type: 'ordinal',
                          colors: ['#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#08589e']
                        }
                      }
                    ]}
                    series={[{dataKey: 'value', valueFormatter}]}
                    width={docWidth}
                    height={300}
                  />}
                </CardContent>
              </Card>
            </Grid>
            <Grid item sm={4} xs={12}>
              <StatisticsCard
                title="Customers"
                count={reportData?.reportItems?.length}
                percentage={{
                  color: "success",
                  label: "Total Customers for period",
                }}
              />
            </Grid>

            <Card sx={{
              marginTop: '15px',
              width: '100%'
            }}>
              <CardContent>

                <MDButton
                  className="pull-right mx-1"
                  color="secondary"
                  size="small"
                  onClick={exportCsv}><span className="fa fa-file-excel"></span>&nbsp;Export</MDButton>

                <MDButton
                  className="pull-right mx-1"
                  color="secondary"
                  size="small"
                  disabled={!selectedRows || selectedRows?.length === 0}
                  onClick={() => {
                    composeEmail()
                  }}><span className="fa fa-email"></span>&nbsp;Compose Email</MDButton>

                <DataTable
                  striped
                  noDataComponent={<MDTypography variant={'p'} className={'cursor-default'}
                                                 fontWeight={'light'}>No
                    Sales Data Found</MDTypography>}
                  columns={columns}
                  keyField={'id'}
                  data={resultsFiltered(reportData?.reportItems)}
                  onSort={handleSort}
                  highlightOnHover
                  onRowClicked={(row) => {
                    // handleRowClick(row);
                  }}

                  selectableRows
                  selectableRowsVisibleOnly
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggledClearRows}
                  pagination
                  paginationPerPage={50}

                  paginationTotalRows={reportData?.reportItems?.length}
                  onChangePage={handlePageChange}
                  progressPending={!reportData}
                  defaultSortFieldId={getCookie('CUSTOMER_REPORT_SORT') || 1}
                  defaultSortAsc={getCookie('CUSTOMER_REPORT_SORT_DIR') === 'desc' ? false : true}
                  paginationComponentOptions={PaginationOptions}
                />

              </CardContent>
            </Card>

          </Grid>
          }
        </MDBox>
      </MDBox>
      <Footer mt={5}/>
    </DashboardLayout>
  );
}